import comp from "./ProgressReportCardImage";
export default comp;
